import SectionHeader from '../components/SectionHeader';
import { features } from '../data/content';

function Feature() {
  return (
    <section className="content-section page-section">
      <SectionHeader label="Feature" title="Our core strengths" />
      <div className="feature-grid">
        {features.map((feature) => (
          <div key={feature.title} className="feature-card">
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Feature;
